module.exports = __webpack_public_path__ + "b12ee1ce3ff3d20bee5191e08db0f098.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/facebook-grey.png
// module id = 999
// module chunks = 2